export const getAppBaseUrl = () => {
  return window.location.origin + (process.env.REACT_APP_BASEPATH ?? '')
}
